export default function WhyClear() {
  const reasons = [
    {
      icon: "ri-file-list-3-line",
      title: "Devis transparent",
      description:
        "Chaque devis détaille le prix de la pièce, la main-d'œuvre et le déplacement. Aucune surprise sur la facture.",
    },
    {
      icon: "ri-puzzle-line",
      title: "Pièce comprise",
      description:
        "Le devis inclut la pièce de rechange nécessaire : crémone, gond, paumelle, poignée, ou mécanisme oscillo-battant.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Validation avant intervention",
      description:
        "Vous validez le devis avant que le technicien ne commence. Si vous refusez, vous ne payez rien — le diagnostic reste gratuit.",
    },
  ];

  return (
    <section className="bg-[#EEF2F4] py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="font-serif italic text-[#1E3A47] text-sm md:text-base mb-2">
            Notre engagement
          </p>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#1E3A47] mb-4">
            Pourquoi nos tarifs sont clairs
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {reasons.map((r) => (
            <div
              key={r.title}
              className="bg-white rounded-2xl border border-[#D7E0E4] p-6 md:p-8"
            >
              <div className="w-12 h-12 rounded-xl bg-[#EEF2F4] flex items-center justify-center mb-4">
                <i className={`${r.icon} text-[#1E3A47] text-xl`} />
              </div>
              <h3 className="font-serif text-lg md:text-xl font-bold text-[#1E3A47] mb-3">
                {r.title}
              </h3>
              <p className="text-[#243038] text-sm md:text-base leading-relaxed">
                {r.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}